import React from "react"

const HelpCircleIcon = ({ size }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{ width: size, height: size }}
			viewBox="0 0 26 26"
			fill="none"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.16699 13.0001C2.16699 7.02658 7.02683 2.16675 13.0003 2.16675C18.9738 2.16675 23.8337 7.02658 23.8337 13.0001C23.8337 18.9736 18.9738 23.8334 13.0003 23.8334C7.02683 23.8334 2.16699 18.9736 2.16699 13.0001ZM4.33366 13.0001C4.33366 17.7787 8.22174 21.6667 13.0003 21.6667C17.7789 21.6667 21.667 17.7787 21.667 13.0001C21.667 8.2215 17.7789 4.33341 13.0003 4.33341C8.22174 4.33341 4.33366 8.2215 4.33366 13.0001ZM9.98831 7.74993C10.7873 6.95099 11.8704 6.50151 13.0003 6.50008C14.1302 6.50123 15.2134 6.95064 16.0122 7.74968C16.8111 8.54871 17.2602 9.63206 17.2611 10.7619C17.2611 12.4909 15.987 13.5229 15.1431 14.2065L15.1399 14.2091C15.125 14.2211 15.1102 14.233 15.0954 14.2449C14.8991 14.403 14.7114 14.5541 14.5603 14.7052C14.1183 15.1462 14.0836 15.547 14.0826 15.5643L14.0836 16.2501H11.917V15.5275C11.917 15.3997 11.9484 14.2524 13.0296 13.1723C13.2682 12.9438 13.518 12.7272 13.7781 12.5234C14.5744 11.8799 15.0955 11.4097 15.0955 10.7619C15.0955 9.606 14.1551 8.66675 13.0003 8.66675C11.8455 8.66675 10.9051 9.606 10.9051 10.7619H8.73847C8.7399 9.63205 9.18938 8.54886 9.98831 7.74993ZM14.0836 17.3334H11.917V19.5001H14.0836V17.3334Z"
				fill="#3F3F46"
			/>
		</svg>
	)
}

export default HelpCircleIcon
